import React, { useEffect, useMemo, useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GroupProps, useFrame } from "@react-three/fiber";
import { assets } from "./Assets";
import * as THREE from "three";
import { BufferGeometry, Mesh, ShaderMaterial, Vector2 } from "three";
import useLoadTexture from "./UseLoadTexture";
import useDarkMode from "../stores/useDarkMode";
import ballonVert from "../shaders/ballon-vert";
import ballonFrag from "../shaders/ballon-frag";

export default function Tent(props: GroupProps) {
  const { nodes } = useGLTF(assets.tent.model);

  const darkModeEnabled = useDarkMode(s => s.darkModeEnabled);

  const textureGround = useLoadTexture(darkModeEnabled ? assets.tent.textures.ground : assets.tent.textures.ground);
  const textureProps = useLoadTexture(darkModeEnabled ? assets.tent.textures.props : assets.tent.textures.props);
  const textureBallons = useLoadTexture(darkModeEnabled ? assets.tent.textures.ballons : assets.tent.textures.ballons);
  const textureID = useLoadTexture(darkModeEnabled ? assets.tent.textures.ballons : assets.tent.textures.ballonsId);

  const buffer = useRef<Mesh>(null!);
  const ballonShader = useRef<ShaderMaterial>(null!);
  const uniforms = useMemo(
    () => {
      let obj = THREE.UniformsLib.fog;
      obj = Object.assign(
        {
          uFrequency: { value: new Vector2(50, 30) },
          uTime: { value: Math.random() * 10 },
          uMap: { value: textureBallons },
          uMapId: { value: textureID },
          uHeight: { value: 10 },
          uLight: { value: 1 },
          uWind: { value: 15 },
        }, obj);
      return obj;
    },
    [textureBallons, textureID]
  );

    useFrame((state, delta) => {
      if (ballonShader?.current) {
        ballonShader.current.uniforms.uTime.value += delta * 0.5;
        ballonShader.current.uniforms.uLight.value = darkModeEnabled ? 0.15 : 1;
      }
    });

  return (
    <group {...props} dispose={null}>
      <group {...props} dispose={null}>
        <mesh
          geometry={(nodes.Ground as Mesh).geometry}
          material={(nodes.Ground as Mesh).material}
        >
          <meshBasicMaterial map={textureGround} />
        </mesh>
        <mesh
          geometry={(nodes.Props as Mesh).geometry}
          material={(nodes.Props as Mesh).material}
        >
          <meshBasicMaterial map={textureProps} />
        </mesh>
         <mesh ref={buffer}
                  geometry={(nodes.Ballons as Mesh).geometry}
                  material={(nodes.Ballons as Mesh).material}
                  
                >
                  {/* <bufferGeometry ref={buffer} /> */}
                   <shaderMaterial
                              fog
                              ref={ballonShader}
                              vertexShader={ballonVert}
                              fragmentShader={ballonFrag}
                              toneMapped={false}
                              uniforms={uniforms}
                            />
                </mesh>
      </group>
    </group>
  );
}